export interface IDocumentViewItem {
    id: string;
    companyId: string;
    directoryItemId: string;
    code: string;
    content: string;
    modifyDate: number;
    modifyName: string;
    modifyPicture: string;
}

export class DocumentViewItem implements IDocumentViewItem {
    id: string;
    companyId: string;
    directoryItemId: string;
    code: string;
    content: string;
    modifyDate: number;
    modifyName: string;
    modifyPicture: string;

    constructor();
    constructor(obj: IDocumentViewItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.directoryItemId = obj && obj.directoryItemId || "";
        this.code = obj && obj.code || "";
        this.content = obj && obj.content || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.modifyName = obj && obj.modifyName || "";
        this.modifyPicture = obj && obj.modifyPicture || "";
    }
}